import { render } from "./OperteItem.vue?vue&type=template&id=dd9fe102&ts=true"
import script from "./OperteItem.vue?vue&type=script&lang=ts"
export * from "./OperteItem.vue?vue&type=script&lang=ts"

import "./OperteItem.vue?vue&type=style&index=0&id=dd9fe102&lang=less"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__